<!--
     <Select
       :props="my_attrs_dictionary"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - items → [[value, text], [1, 'User 1']]
     - value
     - label
     - placeholder
     - multiple
-->

<template>
  <v-select
    v-model="props.value"
    :items="props.items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :readonly="!!props.readonly"
    :item-text="props.item_text || '1'"
    :item-value="props.item_value || '0'"
    :rules="rules"
    :class="[
      props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
      { required: props.required }
    ]"
    outlined
    dense
    background-color="#f2f2f2"
    :clearable="!props.required && !props.readonly"
    :disabled="!!props.disabled || !!props.readonly"
    @change="update"
  >    
    <template>
      <v-icon slot="append" color="primary" v-if="!props.disabled && !props.readonly">
        {{ false || "mdi-menu-down" }}
      </v-icon>
      <div v-else slot="append"></div> <!-- Hide icon -->
    </template>
  </v-select>
</template>


<script>
export default {
  name: 'Select',

  props: ['props'],

  data: () => ({
    valid: true,
  }),

  computed: {
    value() {
      let r = this.props.value || null
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = null
      }
      return r
    },
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },
  },

  methods: {
    validate() {
      // TODO: Show error message
      console.log("Select.valid", this.valid)
      return this.valid
    },
    error_state(ok) {
      this.valid = ok
    },
    update(value) {
      let res = value;
      if (value && value.length <= 0) {
        res = null;
      }
      this.$emit('update',res);
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
